import Header from './Header';
import Footer from './Footer';
import { Masthead } from './Masthead';
import { useLocation } from 'react-router-dom';
import { routes } from '../routes/routes';
import { useState, useEffect } from 'react';
import useAnimateOnScroll from '../hooks/useAnimateOnScroll';
import '../styles/layout/site.scss';

/**
 * The top-level layout component for all pages.
 *
 * @param {object} props The component props.
 * @param {ReactNode} props.children The child elements to render inside the layout.
 *
 * @returns {ReactElement} The page layout component.
 */
const Layout = ({ children }) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [key, setKey] = useState(0);
	const location = useLocation();
	const currentRoute = routes.find((route) => route.path === location.pathname) || routes[0];

	// Initialize scroll animations
	useAnimateOnScroll();

	useEffect(() => {
		setIsLoaded(false);
		setKey((prev) => prev + 1);
		const timer = setTimeout(() => {
			setIsLoaded(true);
		}, 50);
		return () => clearTimeout(timer);
	}, [location.pathname]);

	return (
		<div id="page" className={`bg-white page-${currentRoute.name.toLowerCase().replace(/\s+/g, '-')}`}>
			{currentRoute.masthead && <Masthead key={key} image={currentRoute.masthead.image} alt={currentRoute.masthead.alt} clipPaths={currentRoute.clipPaths} dimensions={currentRoute.masthead.dimensions} transitionDuration={1.2} transitionDelay={0.8} isExpanded={isLoaded} routeName={currentRoute.name} titleAlignment={currentRoute.masthead.titleAlignment} />}
			<Header />
			<main id="main" className="max-w-none prose">
				{children}
			</main>
			<Footer />
		</div>
	);
};

export default Layout;
